import { Checkbox, Icon } from "@fluentui/react";
import { checkboxStyles } from "../../../common/views/DefaultStyles";
import { Utils } from "../../../common/views/Utils";
import { MenuModel } from "../../models/CategoryModel";

export type CategoryMenuItemProps = {
    item: MenuModel;
    hideZeroCount: boolean;
    onChecked: (category: MenuModel, checked: boolean) => void;
    onCollapsed: (category: MenuModel, collapsed: boolean) => void;
}

export default function CategoryMenuItemView({
    item, hideZeroCount, onChecked, onCollapsed
}: CategoryMenuItemProps) {
    //const titleClassName = !item.isNormalText ? "menu-title" : "menu-text";
    const width1 = Utils.getColumnWidth(1);
    const width11 = Utils.getColumnWidth(11);

    const expandCollapseIcon = () => {
        if (item.isCollapsed) {
            return <>
                <Icon
                    iconName="CaretDownSolid8"
                    onClick={() => onCollapsed(item, false)}
                    className="cursor"
                    title={"Expand"}
                    style={{ color: "black", fontSize: "large" }}
                />
            </>;
        } else {
            return <>
                <Icon
                    iconName="CaretUpSolid8"
                    onClick={() => onCollapsed(item, true)}
                    className="cursor"
                    title={"Collapse"}
                    style={{ color: "black", fontSize: "large" }}
                />
            </>;
        }
    }

    const checkbox = () => {
        let count = item.count > 0 ? " (" + item.count + ")" : "";

        return <Checkbox
            label={item.text + count}
            checked={item.isSelected}
            disabled={item.isDisabled}
            onChange={() => onChecked(item, !item.isSelected)}
            styles={checkboxStyles}
        /*styles={{ root: { display: "inline-block" } }}*/
        />
    }
    const mainContent = () => {
        if ((hideZeroCount && item.count <= 0) || !item.isVisibled) return <></>;

        let count = item.count > 0 ? " (" + item.count + ")" : "";
        let padding = item.level * 30;

        return <div className="ms-Grid-row pv-8" style={{ paddingLeft: padding }}>
            <div className={width11}>
                {item.isCheckbox && checkbox()}

                {!item.isCheckbox && !Utils.isNullOrEmpty(item.text) && <>
                    <b className={"menu-title"}>{item.text}{count}</b>
                </>}
            </div>
            <div className={width1 + " right"} style={{ paddingTop: 4 }}>
                {item.lastChild > -1 && expandCollapseIcon()}
            </div>
        </div>;
    }

    return <>
        {mainContent()}
    </>;
}